<template>
  <div>
   <div v-if="!talking">
        <button class="btn-voice" @click="checkApi()">
        <img class="size" src="../../public/img/icons/microphone.svg" alt="microphoe em svg" />
    </button>
   </div>
    <div v-else>
        <button class="btn-voice-talking" @click="checkApi()">
        <img class="size" src="../../public/img/icons/microphone.svg" alt="microphoe em svg" />
    </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VoiceText',
  emits: ['textvoice'],
  props: {
    lang: {
      type: String,
      default: 'pt-BR',
    },
  },
  data: () => ({
    runtimeTranscription: '',
    transcription: '',
    talking: false,
  }),
  methods: {
    checkApi() {
        this.talking = true
      window.SpeechRecognition =
        window.SpeechRecognition || window.webkitSpeechRecognition;
      if (!SpeechRecognition && process.env.NODE_ENV !== 'production') {
        throw new Error(
          'Speech Recognition does not exist on this browser. Use Chrome or Firefox'
        );
      }
      if (!SpeechRecognition) {
        return;
      }
      const recognition = new SpeechRecognition();
      recognition.lang = this.lang;
      recognition.interimResults = false;
      recognition.addEventListener('result', (event) => {
        const text = Array.from(event.results)
          .map((result) => result[0])
          .map((result) => result.transcript)
          .join('');
        this.runtimeTranscription = text;
      });
      recognition.addEventListener('end', () => {
        if (this.runtimeTranscription !== '') {
          this.transcription = this.runtimeTranscription;
          this.$emit('onTranscriptionEnd', {
            transcription: this.transcription,
            lastSentence: this.runtimeTranscription,
          });
        }
        this.$emit('textvoice', this.transcription);
        this.runtimeTranscription = '';
        this.talking = false
      });
      recognition.start();
    },
  },
};
</script>

<style scoped>
    .size {
        width: 18px;
        color: white;
    }
    .btn-voice{
        background-color: white;
        border: solid 1px #ed670c;
        width: 60px;
        height: 40px;
        border-radius: 8px;
    }
    .btn-voice:hover{
        background-color: #ed670c;
        border: solid 1px white;
    }
    .btn-voice-talking{
         background-color: #ed670c;
        border: solid 1px white;
        width: 60px;
        height: 40px;
        border-radius: 8px;
    }
</style>